import {SimpleGrid as ChakraSimpleGrid, SimpleGridProps} from '@chakra-ui/react'

export const SimpleGrid = ({...props}: SimpleGridProps) => {
  return <ChakraSimpleGrid {...props}></ChakraSimpleGrid>
}
export default SimpleGrid
